import "./HowItWorks.scss";

import React, { useState } from "react";
import Slider from "react-slick";
import Button from "../../../DesingSystem/Button/Button";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

const HowItWorks = () => {
  const [readers, setReaders] = useState(false);
  const [writers, setWriters] = useState(true);
  const slider = React.useRef();
  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 1.1,
    className: "how-it-works__container-carrousel-item",
    adaptiveHeight: false,
  };
  const { t } = useTranslation();

  const renderCarrouselReaders = () => {
    return [
      <div >
        <div id="image-1" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_descubre.svg" alt="como funciona bookolicos" />
        </div>{" "}
        <div id="text-1">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">01</p>
          <p className="how-it-works__container-carrousel-title">
            <Trans i18nKey="howItWorksDiscover">
              Descubre
            </Trans>
          </p>
          <p className="how-it-works__container-carrousel-text">
            <Trans i18nKey="howItWorksDiscoverDesc">
              Encuentra nuevos títulos en nuestro catálogo y descubre tu a próximo autor favorito. Personaliza tu búsqueda 
              utilizando nuestros filtros y recibe recomendaciones basadas en tus intereses.
            </Trans>
          </p>
        </div>
      </div>,
      <div>
        <div id="image-2" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_descarga.svg" alt="img" />
        </div>
        <div id="text-2">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">02</p>
          <p className="how-it-works__container-carrousel-title">
            <Trans i18nKey="howItWorksDownload">
              Descarga
            </Trans>
          </p>
          <p className="how-it-works__container-carrousel-text">
            <Trans i18nKey="howItWorksDownloadDesc">
              Obtén todas las obras que desees en formato EPUB, compatibles con cualquier dispositivo de lectura. Realiza pagos 
              de forma fácil y rápida, y ahorra espacio y dinero con las obras en formato digital.
            </Trans>
          </p>
        </div>
      </div>,
      <div>
        {" "}
        <div id="image-3" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_disfruta.svg" alt="img" />
        </div>
        <div id="text-3">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">03</p>
          <p className="how-it-works__container-carrousel-title">
            <Trans i18nKey="howItWorksDownload">
              Disfruta
            </Trans>
          </p>
          <p className="how-it-works__container-carrousel-text">
            Nuestro objetivo es brindar contenidos de calidad. Queremos que nuestros usuarios exploren un catálogo de 
            buenas obras, donde su única preocupación sea descargarlas y sumergirse en ellas.
          </p>
        </div>
      </div>,
    ];
  };

  const renderCarrouselWriters = () => {
    return [
      <div>
        <div id="image-1" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_publica.svg" alt="img" />
        </div>
        <div id="text-1">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">01</p>
          <p className="how-it-works__container-carrousel-title">
            Publica tu obra
          </p>
          <p className="how-it-works__container-carrousel-text">
            Publica todas las obras que quieras de forma sencilla y rápida,
            cumpliendo todos los requisitos legales de una editorial
            tradicional. Ahorra tiempo y dinero en comparación con métodos
            convencionales.
          </p>
        </div>
      </div>,
      <div>
        <div id="image-2" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_ganacias.svg" alt="img" />
        </div>
        <div id="text-2">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">02</p>
          <p className="how-it-works__container-carrousel-title">
            Obtén ganancias
          </p>
          <p className="how-it-works__container-carrousel-text">
            Comienza a ganar como escritor y obtén beneficios de todas las
            ventas de tus obras. Además, podrás acceder a un resumen detallado
            de tus ganancias en cualquier momento.
          </p>
        </div>
      </div>,
      <div>
        {" "}
        <div id="image-3" className="how-it-works__container-carrousel-image">
          <img src="/images/ilustration_crece.svg" alt="img" />
        </div>
        <div id="text-3">
          <div className="how-it-works__border"></div>
          <p className="how-it-works__container-carrousel-number">03</p>
          <p className="how-it-works__container-carrousel-title">
            Crece como autor
          </p>
          <p className="how-it-works__container-carrousel-text">
            Haz que tus obras lleguen más lejos y amplía tu visibilidad tanto
            entre los lectores como ante posibles editoriales interesadas. En
            Bookólicos, nos esforzamos por ser el primer escalón de muchos en tu
            carrera profesional.
          </p>
        </div>
      </div>,
    ];
  };

  const handleReaders = () => {
    setReaders(true);
    setWriters(false);
  };

  const handleWriters = () => {
    setReaders(false);
    setWriters(true);
  };

  return (
    <section className="how-it-works">
      <div className="why-bookolicos__border"> </div>
      <div className="how-it-works__container-title">
        <h2 className="how-it-works__container-title-title">
          <Trans i18nKey="howItWorksTitle">
            Cómo funciona
            <br /> Bookólicos
          </Trans>
        </h2>
        <div className="how-it-works__container-title-container-buttons">
          <div className="how-it-works__container-title-buttons">
            <div className="how-it-works__container-title-buttons-btn">
              <Button
                className={`${writers ? "btn-blackbg" : "btn-simple"}`}
                text={<Trans i18nKey="howItWorksForWriters">Para autores</Trans>}
                onClick={handleWriters}
              />
            </div>
            <div className="how-it-works__container-title-buttons-btn">
              <Button
                className={`${readers ? "btn-blackbg" : "btn-simple"}`}
                text={<Trans i18nKey="howItWorksForReaders">Para lectores</Trans>}
                onClick={handleReaders}
              />
            </div>
          </div>
        </div>
      </div>

      {readers && (
        <div className="how-it-works__container">
          <div id="image-1" className="how-it-works__container-image">
            <img src="/images/ilustration_descubre.svg" alt="ilustracion descubre" />
          </div>
          <div id="image-2" className="how-it-works__container-image">
            <img src="/images/ilustration_descarga.svg" alt="ilustracion descarga" />
          </div>
          <div id="image-3" className="how-it-works__container-image">
            <img src="/images/ilustration_disfruta.svg" alt="ilustracion disfruta" />
          </div>
          <div id="text-1">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">01</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksDiscover">
                Descubre
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksDiscoverDesc">
                Encuentra nuevos títulos en nuestro catálogo y descubre tu a próximo autor favorito. Personaliza tu búsqueda 
                utilizando nuestros filtros y recibe recomendaciones basadas en tus intereses.
              </Trans>
            </p>
          </div>
          <div id="text-2">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">02</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksDownload">
                Descarga
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksDownloadDesc">
                Obtén todas las obras que desees en formato EPUB, compatibles con cualquier dispositivo de lectura. Realiza pagos 
                de forma fácil y rápida, y ahorra espacio y dinero con las obras en formato digital.
              </Trans>
            </p>
          </div>
          <div id="text-3">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">03</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksEnjoy">
                Disfruta
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksEnjoyDesc">
                Nuestro objetivo es brindar contenidos de calidad. Queremos que
                nuestros usuarios exploren un catálogo de buenas obras, donde su
                única preocupación sea descargarlas y sumergirse en ellas.
              </Trans>
            </p>
          </div>
        </div>
      )}

      {writers && (
        <div className="how-it-works__container">
          <div id="image-1" className="how-it-works__container-image">
            <img src="/images/ilustration_publica.svg" alt="ilustracion publica obra" />
          </div>
          <div id="image-2" className="how-it-works__container-image">
            <img src="/images/ilustration_ganacias.svg" alt="ilustracion obten ganancias" />
          </div>
          <div id="image-3" className="how-it-works__container-image">
            <img src="/images/ilustration_crece.svg" alt="ilustracion crece" />
          </div>
          <div id="text-1">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">01</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksPublish">
                Publica tu obra
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksPublishDesc">
                Publica todas las obras que quieras de forma sencilla y rápida,
                cumpliendo todos los requisitos legales de una editorial
                tradicional. Ahorra tiempo y dinero en comparación con métodos
                convencionales.
              </Trans>
            </p>
          </div>
          <div id="text-2">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">02</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksRevenue">
                Obtén ganancias
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksRevenueDesc">
                Comienza a ganar como escritor y obtén beneficios de todas las
                ventas de tus obras. Además, podrás acceder a un resumen detallado
                de tus ganancias en cualquier momento.
              </Trans>
            </p>
          </div>
          <div id="text-3">
            <div className="how-it-works__border"></div>
            <p className="how-it-works__container-number">03</p>
            <p className="how-it-works__container-title">
              <Trans i18nKey="howItWorksGrow">
                Crece como autor
              </Trans>
            </p>
            <p className="how-it-works__container-text">
              <Trans i18nKey="howItWorksGrowDesc">
                Haz que tus obras lleguen más lejos y amplía tu visibilidad tanto
                entre los lectores como ante posibles editoriales interesadas. En
                Bookólicos, nos esforzamos por ser el primer escalón de muchos en
                tu carrera profesional.
              </Trans>
            </p>
          </div>
        </div>
      )}

      {readers && (
        <div className="how-it-works__container-carrousel">
          <Slider ref={slider} {...settings}>
            {renderCarrouselReaders()}
          </Slider>
        </div>
      )}

      {writers && (
        <div className="how-it-works__container-carrousel">
          <Slider ref={slider} {...settings}>
            {renderCarrouselWriters()}
          </Slider>
        </div>
      )}
    </section>
  );
};

export default HowItWorks;
